import { faExclamationCircle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import { OverlayTrigger, OverlayTriggerProps, Popover } from "react-bootstrap";
import { formatBytes } from "../../../../../../../../utilities/helpers";
import { COMBINED_FILE_SIZE_LIMIT, getCombinedFileSize } from "../../SourceSelectionPage";
import { SourceFilesListProps } from "./SourceFilesList";
import { millisecondsToTimeString } from "./SourceFilesListItem";

export default function SourceFilesListSummary(props: SourceFilesListProps) {
    const combinedFileSize = getCombinedFileSize(props.sourceFiles);
    const overLimit = combinedFileSize - COMBINED_FILE_SIZE_LIMIT;
    const isWithinLimit = overLimit <= 0;

    const count = props.sourceFiles.length;
    const size = formatBytes(combinedFileSize);
    const duration = millisecondsToTimeString(
        dayjs.duration(props.sourceFiles.reduce((acc, f) => acc + (f.duration ?? 0), 0)).asMilliseconds(),
    );

    const overlayProps = { placement: "bottom", delay: { show: 250, hide: 350 } } as OverlayTriggerProps;

    return (
        <div className="file-list-summary">
            <div className="gap-3 d-flex justify-content-center text-muted mt-1">
                <OverlayTrigger
                    {...overlayProps}
                    overlay={
                        <Popover>
                            <Popover.Body>Number of files</Popover.Body>
                        </Popover>
                    }
                >
                    <span>
                        <span>File count:</span> {count}
                    </span>
                </OverlayTrigger>

                <OverlayTrigger
                    {...overlayProps}
                    overlay={
                        <Popover>
                            <Popover.Body className={isWithinLimit ? "" : "text-danger"}>
                                {isWithinLimit
                                    ? "Combined size of all files"
                                    : `The combined size of the files exceeds the limit of ${formatBytes(
                                          COMBINED_FILE_SIZE_LIMIT,
                                      )}. Please remove at least ${formatBytes(
                                          overLimit,
                                      )} worth of files from the list.`}
                            </Popover.Body>
                        </Popover>
                    }
                >
                    <span className={`${isWithinLimit ? "" : "text-danger"}`}>
                        <span>Total size: </span>
                        <span>
                            {size} {!isWithinLimit && <FontAwesomeIcon icon={faExclamationCircle} />}
                        </span>
                    </span>
                </OverlayTrigger>

                <OverlayTrigger
                    {...overlayProps}
                    overlay={
                        <Popover>
                            <Popover.Body>Combined duration of all files</Popover.Body>
                        </Popover>
                    }
                >
                    <span>Total duration: {duration}</span>
                </OverlayTrigger>
            </div>
        </div>
    );
}
